import React, { useEffect } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { useNavigate } from "react-router-dom";
function Home() {
  const { authState } = useOktaAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (authState.isAuthenticated) {
      navigate("/policies-active", {
        replace: true,
        state: { pageType: "Active" },
      });
    }
  }, [authState, navigate]);
  return <div>Home</div>;
}

export default Home;
